// Environment configuration
interface ApiEndpoints {
    auth: {
        login: string;
        validate: string;
        me: string;
        logout: string;
    };
    // Add other endpoint groups as needed
}

interface EnvironmentConfig {
    isProduction: boolean;
    domain: string;
    /** Canonical origin where this app is served. Use for OAuth redirect URIs (Google/Azure AD). */
    appOrigin: string;
    enableLogging: boolean;
    api: {
        baseUrl: string;
        endpoints: ApiEndpoints;
    };
    auth: {
        google: {
            clientId: string;
            /** Redirect URI to register in Google Cloud Console (SPA: use origin). */
            redirectUri: string;
        };
        microsoft: {
            clientId: string;
            authority: string;
            /** Redirect URI to register in Azure AD app registration (SPA: use origin). */
            redirectUri: string;
        };
    };
    ui: {
        snackbar: {
            autoHideDuration: number;
            anchorOrigin: {
                vertical: 'top' | 'bottom';
                horizontal: 'left' | 'center' | 'right';
            };
        };
    };
}

// Development configuration (local: localhost; deployed dev: appdev.dpdpkavach.com)
const devConfig: EnvironmentConfig = {
    isProduction: false,
    domain: 'localhost',
    appOrigin: process.env.REACT_APP_DEV_APP_ORIGIN || 'http://localhost:3000',
    enableLogging: true,
    api: {
        baseUrl: process.env.REACT_APP_DEV_API_BASE_URL || 'http://localhost:3001',
        endpoints: {
            auth: {
                login: '/auth/login',
                validate: '/auth/validate',
                me: '/auth/me',
                logout: '/auth/logout'
            }
        }
    },
    auth: {
        google: {
            clientId: process.env.REACT_APP_DEV_GOOGLE_CLIENT_ID || '',
            redirectUri: process.env.REACT_APP_DEV_APP_ORIGIN || 'http://localhost:3000'
        },
        microsoft: {
            clientId: process.env.REACT_APP_DEV_MICROSOFT_CLIENT_ID || '',
            authority: process.env.REACT_APP_DEV_MICROSOFT_AUTHORITY || 'https://login.microsoftonline.com/common',
            redirectUri: process.env.REACT_APP_DEV_APP_ORIGIN || 'http://localhost:3000'
        }
    },
    ui: {
        snackbar: {
            autoHideDuration: 5000, // 5 seconds in milliseconds
            anchorOrigin: {
                vertical: 'top' as const,
                horizontal: 'center' as const
            }
        }
    }
};

// Production configuration (app.privigo.ai)
const prodConfig: EnvironmentConfig = {
    isProduction: true,
    domain: 'privigo.ai',
    appOrigin: process.env.REACT_APP_PROD_APP_ORIGIN || 'https://app.privigo.ai',
    enableLogging: false,
    api: {
        baseUrl: process.env.REACT_APP_PROD_API_BASE_URL || 'https://api.privigo.ai',
        endpoints: {
            auth: {
                login: '/auth/login',
                validate: '/auth/validate',
                me: '/auth/me',
                logout: '/auth/logout'
            }
        }
    },
    auth: {
        google: {
            clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
            redirectUri: process.env.REACT_APP_PROD_APP_ORIGIN || 'https://app.privigo.ai'
        },
        microsoft: {
            clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || '',
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY || 'https://login.microsoftonline.com/common',
            redirectUri: process.env.REACT_APP_PROD_APP_ORIGIN || 'https://app.privigo.ai'
        }
    },
    ui: {
        snackbar: {
            autoHideDuration: 5000, // 5 seconds in milliseconds
            anchorOrigin: {
                vertical: 'top' as const,
                horizontal: 'center' as const
            }
        }
    }
};

// Export the appropriate configuration based on environment
//~! REACT sent the NODE_ENV on its own depending on how the build was created. with npm start it is development and with npm run build it is production.
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('REACT_APP_DEV_API_BASE_URL:', process.env.NODE_ENV === 'production' ? prodConfig : devConfig);
export const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig; 